import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { THUMBNAIL_PREFERENCES } from "~/constants/localStorageKeys";
const THUMBNAIL_PREFERENCES_CLASS_NAME_MAP = {
    default: "object-cover",
    contain: "object-contain",
    cover: "object-cover",
    fill: "object-fill",
    "scale-down": "object-scale-down"
};
export const getPreferenceClassName = (preference)=>{
    if (preference) {
        return THUMBNAIL_PREFERENCES_CLASS_NAME_MAP[preference];
    }
    return "";
};
export const ThumbnailPreferenceContext = /*#__PURE__*/ createContext(null);
export const ThumbnailPreferenceContextProvider = (param)=>{
    let { children } = param;
    const [preferences, setPreferences] = useState([]);
    useEffect(()=>{
        const update = ()=>{
            const preferences = localStorage.getItem(THUMBNAIL_PREFERENCES);
            if (preferences) {
                setPreferences(JSON.parse(preferences));
            }
        };
        window.addEventListener("storage", update);
        update();
        return ()=>{
            window.removeEventListener("storage", update);
        };
    }, []);
    const updatePreference = useCallback((boardId, value)=>{
        let newPreferences;
        if (preferences.find((preference)=>preference.id === boardId)) {
            newPreferences = preferences.map((preference)=>{
                if (preference.id === boardId) {
                    return {
                        ...preference,
                        value
                    };
                }
                return preference;
            });
        } else {
            newPreferences = [
                ...preferences,
                {
                    id: boardId,
                    value
                }
            ];
        }
        setPreferences(newPreferences);
        localStorage.setItem(THUMBNAIL_PREFERENCES, JSON.stringify(newPreferences));
    }, [
        preferences
    ]);
    const getPreference = useCallback((boardId)=>{
        var _preferences_find;
        if (!boardId) return;
        return (preferences === null || preferences === void 0 ? void 0 : (_preferences_find = preferences.find((preference)=>preference.id === boardId)) === null || _preferences_find === void 0 ? void 0 : _preferences_find.value) || "default";
    }, [
        preferences
    ]);
    const value = useMemo(()=>({
            getPreference,
            updatePreference
        }), [
        getPreference,
        updatePreference
    ]);
    return /*#__PURE__*/ _jsx(ThumbnailPreferenceContext.Provider, {
        value: value,
        children: children
    });
};
export const useThumbnailPreference = ()=>{
    const context = useContext(ThumbnailPreferenceContext);
    if (!context) {
        throw new Error("useThumbnailPreference must be used within ThumbnailPreferenceContextProvider");
    }
    return context;
};
